import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class ChallengeModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "username", '');
    _defineProperty(this, "loading", false);
    _defineProperty(this, "searching", false);
    _defineProperty(this, "error", null);
    _defineProperty(this, "suggestions", []);
    _defineProperty(this, "showSuggestions", false);
    _defineProperty(this, "searchTimer", null);
    _defineProperty(this, "loadingDecks", true);
    _defineProperty(this, "readyDeckSlots", []);
    _defineProperty(this, "selectedDeckSlotId", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    if (this.attrs.opponent) {
      var _this$attrs$opponent$;
      this.username = (_this$attrs$opponent$ = this.attrs.opponent.username()) != null ? _this$attrs$opponent$ : '';
    }
    this.loadDeckSlots();
  }
  async loadDeckSlots() {
    this.loadingDecks = true;
    m.redraw();
    try {
      var _response$slots, _this$readyDeckSlots$, _this$readyDeckSlots$2;
      const response = await app.request({
        method: 'GET',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/deck-slots")
      });
      const slots = (_response$slots = response == null ? void 0 : response.slots) != null ? _response$slots : [];
      this.readyDeckSlots = slots.filter(s => s.cardCount === 20);
      this.selectedDeckSlotId = (_this$readyDeckSlots$ = (_this$readyDeckSlots$2 = this.readyDeckSlots[0]) == null ? void 0 : _this$readyDeckSlots$2.id) != null ? _this$readyDeckSlots$ : null;
    } catch (_unused) {
      this.readyDeckSlots = [];
      this.selectedDeckSlotId = null;
    } finally {
      this.loadingDecks = false;
      m.redraw();
    }
  }
  className() {
    return 'ArenaChallengeModal Modal--small';
  }
  title() {
    return m('[', null, m("i", {
      className: "fas fa-swords"
    }), " ", app.translator.trans('forumaker-arena.forum.challenge_modal.title'));
  }
  onremove() {
    if (this.searchTimer) clearTimeout(this.searchTimer);
  }
  onInput(value) {
    this.username = value;
    this.error = null;
    this.showSuggestions = false;
    if (this.searchTimer) clearTimeout(this.searchTimer);
    if (value.trim().length >= 3) {
      this.searching = true;
      m.redraw();
      this.searchTimer = setTimeout(() => this.searchUsers(value.trim()), 350);
    } else {
      this.suggestions = [];
      this.searching = false;
    }
  }
  async searchUsers(query) {
    try {
      var _response$data;
      const response = await app.request({
        method: 'GET',
        url: "".concat(app.forum.attribute('apiUrl'), "/users"),
        params: {
          'filter[q]': query,
          'page[limit]': 5
        }
      });
      const data = (_response$data = response == null ? void 0 : response.data) != null ? _response$data : [];
      this.suggestions = data.map(u => {
        var _u$attributes$usernam, _u$attributes, _ref, _u$attributes$display, _u$attributes2, _u$attributes3, _u$attributes$avatarU, _u$attributes4;
        return {
          id: u.id,
          username: (_u$attributes$usernam = (_u$attributes = u.attributes) == null ? void 0 : _u$attributes.username) != null ? _u$attributes$usernam : '',
          displayName: (_ref = (_u$attributes$display = (_u$attributes2 = u.attributes) == null ? void 0 : _u$attributes2.displayName) != null ? _u$attributes$display : (_u$attributes3 = u.attributes) == null ? void 0 : _u$attributes3.username) != null ? _ref : '',
          avatarUrl: (_u$attributes$avatarU = (_u$attributes4 = u.attributes) == null ? void 0 : _u$attributes4.avatarUrl) != null ? _u$attributes$avatarU : null
        };
      }).filter(u => {
        var _app$session$user;
        return u.id !== ((_app$session$user = app.session.user) == null ? void 0 : _app$session$user.id());
      });
      this.showSuggestions = this.suggestions.length > 0;
    } catch (_unused2) {
      this.suggestions = [];
      this.showSuggestions = false;
    }
    this.searching = false;
    m.redraw();
  }
  selectUser(user) {
    this.username = user.username;
    this.suggestions = [];
    this.showSuggestions = false;
    m.redraw();
  }
  content() {
    var _app$forum$attribute, _app$forum$attribute2, _app$forum$attribute3, _this$selectedDeckSlo;
    // Waiting out the deck-slots fetch behind a single spinner, instead of
    // rendering the full form immediately and letting the deck-select block
    // pop in a moment later, avoids the jarring reflow that used to shift
    // everything below it down once the request resolved.
    if (this.loadingDecks) {
      return m("div", {
        className: "Modal-body ArenaChallengeModal-loading"
      }, m(LoadingIndicator, null));
    }
    const hasDeck = this.readyDeckSlots.length > 0;
    const maxHp = (_app$forum$attribute = app.forum.attribute('arenaMaxHp')) != null ? _app$forum$attribute : 15;
    const maxMana = (_app$forum$attribute2 = app.forum.attribute('arenaMaxMana')) != null ? _app$forum$attribute2 : 20;
    const maxTurns = (_app$forum$attribute3 = app.forum.attribute('arenaMaxTurns')) != null ? _app$forum$attribute3 : 10;
    return m("div", {
      className: "Modal-body"
    }, this.error && m("div", {
      className: "Alert Alert--error",
      style: {
        marginBottom: '12px'
      }
    }, m("i", {
      className: "fas fa-exclamation-circle"
    }), " ", this.error), !hasDeck && m("div", {
      className: "Alert Alert--warning",
      style: {
        marginBottom: '12px'
      }
    }, m("i", {
      className: "fas fa-exclamation-triangle"
    }), ' ', app.translator.trans('forumaker-arena.forum.challenge_modal.no_deck'), ' ', m("a", {
      className: "ArenaChallengeModal-buildDeckLink",
      href: "#",
      onclick: e => {
        var _app$session$user$use, _app$session$user2;
        e.preventDefault();
        this.hide();
        m.route.set(app.route('user.arena', {
          username: (_app$session$user$use = (_app$session$user2 = app.session.user) == null ? void 0 : _app$session$user2.username()) != null ? _app$session$user$use : ''
        }));
      }
    }, app.translator.trans('forumaker-arena.forum.challenge_modal.build_deck'))), m("div", {
      className: "ArenaChallengeModal-rules"
    }, m("div", {
      className: "ArenaChallengeModal-rule ArenaChallengeModal-rule--hp"
    }, m("i", {
      className: "fas fa-heart"
    }), m("span", {
      className: "ArenaChallengeModal-ruleValue"
    }, maxHp), m("span", {
      className: "ArenaChallengeModal-ruleLabel"
    }, app.translator.trans('forumaker-arena.forum.challenge_modal.hp_label'))), m("div", {
      className: "ArenaChallengeModal-rule ArenaChallengeModal-rule--mana"
    }, m("i", {
      className: "fas fa-gem"
    }), m("span", {
      className: "ArenaChallengeModal-ruleValue"
    }, maxMana), m("span", {
      className: "ArenaChallengeModal-ruleLabel"
    }, app.translator.trans('forumaker-arena.forum.challenge_modal.mana_label'))), m("div", {
      className: "ArenaChallengeModal-rule ArenaChallengeModal-rule--turns"
    }, m("i", {
      className: "fas fa-list-ol"
    }), m("span", {
      className: "ArenaChallengeModal-ruleValue"
    }, maxTurns), m("span", {
      className: "ArenaChallengeModal-ruleLabel"
    }, app.translator.trans('forumaker-arena.forum.challenge_modal.turns_label', {
      maxTurns
    }))), m("div", {
      className: "ArenaChallengeModal-rule ArenaChallengeModal-rule--time"
    }, m("i", {
      className: "fas fa-clock"
    }), m("span", {
      className: "ArenaChallengeModal-ruleValue"
    }, app.translator.trans('forumaker-arena.forum.challenge_modal.turn_time_value')), m("span", {
      className: "ArenaChallengeModal-ruleLabel"
    }, app.translator.trans('forumaker-arena.forum.challenge_modal.per_turn_label')))), hasDeck && m("div", {
      className: "Form-group ArenaChallengeModal-deckWrap"
    }, m("label", null, app.translator.trans('forumaker-arena.forum.challenge_modal.deck_label')), m("select", {
      className: "FormControl",
      value: (_this$selectedDeckSlo = this.selectedDeckSlotId) != null ? _this$selectedDeckSlo : '',
      onchange: e => {
        this.selectedDeckSlotId = parseInt(e.target.value, 10);
      }
    }, this.readyDeckSlots.map(slot => m("option", {
      key: slot.id,
      value: slot.id
    }, slot.name)))), m("div", {
      className: "Form-group ArenaChallengeModal-searchWrap"
    }, m("label", null, app.translator.trans('forumaker-arena.forum.challenge_modal.opponent_label')), !this.attrs.opponent && m("p", {
      className: "ArenaChallengeModal-opponentHint helpText"
    }, app.translator.trans('forumaker-arena.forum.challenge_modal.opponent_hint')), m("div", {
      style: {
        position: 'relative'
      }
    }, m("input", {
      className: "FormControl",
      type: "text",
      placeholder: app.translator.trans('forumaker-arena.forum.challenge_modal.search_placeholder'),
      value: this.username,
      oninput: e => this.onInput(e.target.value),
      onkeydown: e => {
        if (e.key === 'Enter' && !this.showSuggestions) this.submit();
        if (e.key === 'Escape') {
          this.showSuggestions = false;
          m.redraw();
        }
      },
      disabled: this.loading
    }), this.searching && m("div", {
      className: "ArenaChallengeModal-searching"
    }, m("i", {
      className: "fas fa-circle-notch fa-spin"
    }), ' ', app.translator.trans('forumaker-arena.forum.challenge_modal.searching')), this.showSuggestions && m("ul", {
      className: "ArenaChallengeModal-suggestions"
    }, this.suggestions.map(u => {
      var _u$displayName$;
      return m("li", {
        key: u.id,
        className: "ArenaChallengeModal-suggestion",
        onmousedown: e => {
          e.preventDefault();
          this.selectUser(u);
        }
      }, u.avatarUrl ? m("img", {
        className: "ArenaChallengeModal-avatar",
        src: u.avatarUrl,
        alt: ""
      }) : m("span", {
        className: "ArenaChallengeModal-avatarFallback"
      }, ((_u$displayName$ = u.displayName[0]) != null ? _u$displayName$ : '?').toUpperCase()), m("span", {
        className: "ArenaChallengeModal-suggestionName"
      }, u.displayName), u.displayName !== u.username && m("span", {
        className: "ArenaChallengeModal-suggestionUsername"
      }, "@", u.username));
    })))), m("div", {
      className: "Form-group ArenaChallengeModal-submitGroup"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      loading: this.loading,
      disabled: !hasDeck || this.selectedDeckSlotId == null || this.loading ||
      // A preset opponent (challenging from their profile) always
      // needs a name — only the generic entry point allows leaving
      // it blank to create an open lobby instead.
      !!this.attrs.opponent && !this.username.trim(),
      onclick: () => this.submit()
    }, m("i", {
      className: "fas fa-swords"
    }), " ", app.translator.trans('forumaker-arena.forum.challenge_modal.submit'))));
  }

  /**
   * A blank opponent field creates an open lobby anyone eligible can join
   * (see CreateBattleController::handleOpenBattle) instead of challenging a
   * named player — same single button either way, decided purely by whether
   * the field was left empty.
   */
  async submit() {
    const username = this.username.trim();
    if (this.selectedDeckSlotId == null) return;
    if (!username && this.attrs.opponent) return;
    this.loading = true;
    this.error = null;
    this.showSuggestions = false;
    m.redraw();
    if (!username) {
      return this.submitOpen();
    }
    try {
      const result = await app.request({
        method: 'POST',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/battles"),
        body: {
          opponentUsername: username,
          deckSlotId: this.selectedDeckSlotId
        },
        // Suppress Flarum's default global error alert (bottom-left box):
        // our controller replies with a custom JSON shape it can't render a
        // message from, and the modal shows its own error banner anyway.
        // The promise still rejects, so the catch below runs as before.
        errorHandler: () => {}
      });
      this.hide();
      m.route.set(result.discussionUrl);
    } catch (e) {
      var _ref2, _ref3, _e$response, _e$response2, _ref4, _body$error, _body$errors;
      // Flarum's RequestError puts the parsed JSON body directly on
      // e.response (not e.response.body) — our controller replies with a
      // custom JSON shape {error, battleId, discussionId}, not the standard
      // JSON:API {errors}.
      const body = (_ref2 = (_ref3 = (_e$response = e == null ? void 0 : e.response) != null ? _e$response : e == null || (_e$response2 = e.response) == null ? void 0 : _e$response2.body) != null ? _ref3 : e == null ? void 0 : e.responseJSON) != null ? _ref2 : {};

      // If a battle with this player already exists, redirect there instead
      if (body != null && body.discussionId) {
        this.hide();
        m.route.set('/d/' + body.discussionId);
        return;
      }
      this.error = (_ref4 = (_body$error = body == null ? void 0 : body.error) != null ? _body$error : body == null || (_body$errors = body.errors) == null || (_body$errors = _body$errors[0]) == null ? void 0 : _body$errors.detail) != null ? _ref4 : app.translator.trans('forumaker-arena.forum.challenge_modal.error_generic');
      this.loading = false;
      m.redraw();
    }
  }

  /**
   * Creates a battle with no opponent picked — anyone eligible can join it
   * afterward from the discussion (see JoinBattleController / ArenaBattleOpenPost).
   * Called from submit() above when the opponent field was left empty;
   * this.loading/this.error are already set by the caller.
   */
  async submitOpen() {
    try {
      const result = await app.request({
        method: 'POST',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/battles"),
        body: {
          open: true,
          deckSlotId: this.selectedDeckSlotId
        },
        // Same global-alert suppression as submit() above.
        errorHandler: () => {}
      });
      this.hide();
      m.route.set(result.discussionUrl);
    } catch (e) {
      var _ref5, _ref6, _e$response3, _e$response4, _ref7, _body$error2, _body$errors2;
      const body = (_ref5 = (_ref6 = (_e$response3 = e == null ? void 0 : e.response) != null ? _e$response3 : e == null || (_e$response4 = e.response) == null ? void 0 : _e$response4.body) != null ? _ref6 : e == null ? void 0 : e.responseJSON) != null ? _ref5 : {};
      if (body != null && body.discussionId) {
        this.hide();
        m.route.set('/d/' + body.discussionId);
        return;
      }
      this.error = (_ref7 = (_body$error2 = body == null ? void 0 : body.error) != null ? _body$error2 : body == null || (_body$errors2 = body.errors) == null || (_body$errors2 = _body$errors2[0]) == null ? void 0 : _body$errors2.detail) != null ? _ref7 : app.translator.trans('forumaker-arena.forum.challenge_modal.error_generic');
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ChallengeModal', ChallengeModal);